import React, {Fragment} from 'react';
import {GoodsCreateRequestStatus} from "../../../graphql/types";
import {useTranslation} from "react-i18next";

export const BadgeGoodsCreateRequestStatus = (props: {
    status: GoodsCreateRequestStatus
}) => {
    const [t] = useTranslation('common');

    return (
        <Fragment>
            {GoodsCreateRequestStatus.Requested === props.status && <span className='badge badge-warning'>{t('mypageGoods.badgeRequested')}</span>}
            {GoodsCreateRequestStatus.AdminCancel === props.status && <span className='badge badge-danger'>{t('mypageGoods.badgeAdminCancel')}</span>}
            {GoodsCreateRequestStatus.AdminConfirm === props.status && <span className='badge badge-success'>{t('mypageGoods.badgeAdminConfirm')}</span>}
            {GoodsCreateRequestStatus.UserCancel === props.status && <span className='badge badge-secondary'>{t('mypageGoods.badgeUserCancel')}</span>}
            {GoodsCreateRequestStatus.Done === props.status && <span className='badge badge-success'>{t('mypageGoods.badgeDone')}</span>}
        </Fragment>
    )
}
